export const loadPluralMapping = {
  '=0': '0 Loads',
  '=1': '1 Load',
  other: '# Loads',
};
